import React from "react";
import { FormatMessage } from "react-globalize";
import Globalize, { locale } from "globalize";

export default function GLBANotice(props)
{

  const getBulletAndText = (targetClass, messagePath) => {
    return [
    <span data-toggle="collapse" data-target={"." + targetClass} className={targetClass + " collapse collapseIcon iconOver"} role="button">
      <i className="fa fa-caret-up" ></i>
    </span>,
    <span data-toggle="collapse" data-target={"." + targetClass} className=" collapseIcon iconUnder" role="button">
      <i className="fa fa-caret-right" style={{paddingLeft:1}}></i>
    </span>,
    <FormatMessage locale={props.locale} path={messagePath} data-toggle="collapse" data-target={"." + targetClass} role="button"/>
    ];
  }

  const getListItems = (amount, messagePath) => {
    let result = [];
    for(let index = 0; index < amount; index++) {
      result = [...result, <li><FormatMessage locale={props.locale} path={messagePath + "/" + index} /></li>]
    }
     return result;
  }

  const getTableBodyRows = () => {
    let result = [];
    for(let index = 0; index < 7; index++) {
      result = [...result, 
      <tr>
        <td>
          <h5><FormatMessage locale={props.locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/reason/title"} /></h5>
          <p>{Globalize(props.locale).formatMessage("glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/reason/note").trim()}</p>
        </td>
        <td>
          <FormatMessage locale={props.locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/shared"} />
        </td>
        <td>
          <FormatMessage locale={props.locale} path={"glbaNoticePage/whatInformation/how/reasonsTable/body/" + index + "/boundable"} />
        </td>
      </tr>
      ]
    }
    return result;
  }

  return (<section id="glbaNoticeSection" className="content-section about-section sectionPage">
    <div className="row">
      <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
        <div className="title-v1">
            <div className="col-sm-12   col-xs-12">
              <h1 className="text-center">
                <FormatMessage locale={props.locale} path="glbaNoticePage/title" />
              </h1>
            <hr className="small"/>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
        <div className="title">
          <h3><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/title" /></h3>
        </div>

        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatWithPersonalInformationWhy", "glbaNoticePage/whatInformation/why/title")}</h4>
          <div className="whatWithPersonalInformationWhy collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/why/answer" /></p>
          </div>
        </div>

        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatWithPersonalInformationWhat", "glbaNoticePage/whatInformation/what/title")}</h4>
          <div className="whatWithPersonalInformationWhat collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/what/answer"/></p>
            <ul>
              {getListItems(5, "glbaNoticePage/whatInformation/what/includedList")}
            </ul>
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/what/afterService"/></p>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatWithPersonalInformationHow", "glbaNoticePage/whatInformation/how/title")}</h4>
          <div className="whatWithPersonalInformationHow collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/how/details" /></p>
            <table class="table">
              <thead>
                <tr>
                  <th><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/how/reasonsTable/headers/reasons" /></th>
                  <th><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/how/reasonsTable/headers/shared" /></th>
                  <th><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/how/reasonsTable/headers/boundable" /></th>
                </tr>
              </thead>
              <tbody>
                {getTableBodyRows()}
              </tbody>
            </table>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatWithPersonalInformationToLimit", "glbaNoticePage/whatInformation/toLimit/title")}</h4>
          <div className="whatWithPersonalInformationToLimit collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/toLimit/info" elements={{phone: <a className="strong" href="tel:+18009262277"></a>, link: <a className="strong" href="https://www.barri.com"></a>}} /></p>
            <b><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/toLimit/note/title"/></b>
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/toLimit/note/info"/></p>
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/toLimit/note/ps"/></p>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatWithPersonalInformationQuestions", "glbaNoticePage/whatInformation/questions/title")}</h4>
          <div className="whatWithPersonalInformationQuestions collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatInformation/questions/info" elements={{phone: <a className="strong" href="tel:+18009262277"></a>, link: <a className="strong" href="https://www.barri.com"></a>}}/></p>
          </div>
        </div>
        <div className="title">
          <h3><FormatMessage locale={props.locale} path="glbaNoticePage/who/title" /></h3>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whoQuestions", "glbaNoticePage/who/whoProvides/title")}</h4>
          <div className="whoQuestions collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/who/whoProvides/answer"/></p>
          </div>
        </div>
        <div className="title">
          <h3><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/title" /></h3>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("howProtect", "glbaNoticePage/whatWeDo/howProtect/title")}</h4>
          <div className="howProtect collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/howProtect/answer"/></p>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("howCollect", "glbaNoticePage/whatWeDo/howCollect/title")}</h4>
          <div className="howCollect collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/howCollect/answer"/></p>
            <ul>
              {getListItems(3, "glbaNoticePage/whatWeDo/howCollect/includedList")}
            </ul>
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/howCollect/afterService"/></p>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whyAll", "glbaNoticePage/whatWeDo/whyAll/title")}</h4>
          <div className="whyAll collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/whyAll/answer"/></p>
            <ul>
              {getListItems(3, "glbaNoticePage/whatWeDo/whyAll/includedList")}
            </ul>
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/whyAll/afterService"/></p>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("whatHappens", "glbaNoticePage/whatWeDo/whatHappens/title")}</h4>
          <div className="whatHappens collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/whatWeDo/whatHappens/answer"/></p>
          </div>
        </div>
        <div className="title" >
          <h3><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/title" /></h3>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("affiliates", "glbaNoticePage/definitions/affiliates/title")}</h4>
          <div className="affiliates collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/affiliates/definition"/></p>
            <ul>
              <li><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/affiliates/notes"/></li>
            </ul>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("nonaffiliates", "glbaNoticePage/definitions/nonaffiliates/title")}</h4>
          <div className="nonaffiliates collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/nonaffiliates/definition"/></p>
            <ul>
              <li><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/nonaffiliates/notes"/></li>
            </ul>
          </div>
        </div>
        <div className="div">
          <h4 className="subTitle">{getBulletAndText("jointMarketing", "glbaNoticePage/definitions/jointMarketing/title")}</h4>
          <div className="jointMarketing collapse collapsebleDiv">
            <p><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/jointMarketing/definition"/></p>
            <ul>
              <li><FormatMessage locale={props.locale} path="glbaNoticePage/definitions/jointMarketing/notes"/></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>)
  }



// WEBPACK FOOTER //
// ./js/sectionGLBANotice.js